<template>
    <div id="modal" class="modal modal_size">

        <drm-auth />

        <a
            href="javascript:"
            class="ui_close"
            type="button"
            rel="modal:close"
            @click="onContinueClick"
        >
            <span class="sr_only">popup close</span>
        </a>
        <dl class="modal_content">
            <dt class="ellipsis maintit">
                <i>Logged In Successfully!</i>
            </dt>
            <div class="modal_txt">
                <div style="height: 140px; line-height: 70px; text-align: center;">
                    Please click 'continue' to proceed!
                </div>
            </div>
            <!-- <ul class="w100 mt-10">
                <li></li>
                <li class="mt-10"></li>
            </ul> -->

            <div class="btn_wrap topLine">
                <div class="btn_right pc_only">
                    <a href="javascript:" class="btn_blue" title @click="onContinueClick">Continue</a>
                </div>
            </div>
        </dl>
    </div>
</template>


<script>
import axios from 'axios';
import { SDLUtil, DateUtil, CertUtil } from '@/utils';

import qs from 'query-string';
import { EventBus } from '@/utils/EventBus';

import DrmAuth from './DrmAuth';

export default {
    name: 'hhp-login-success',
    components: {
        'drm-auth': DrmAuth,
    },
    props: [],
    data() {
        return {
            isLoading: true,

            userId: '',
            randomStr: '',

            nsdReturnCode: null,
        };
    },
    computed: {},

    created() {
    },
    mounted() {
    },

    methods: {
        onContinueClick() {
            const path = localStorage.getItem('hhp_redirect');
            if (path) {
                localStorage.removeItem('hhp_redirect');
                this.$router.push({ path });

            } else {
                this.$emit('close');
                this.$router.push({ name: 'anysvcCertHome' });
                EventBus.$emit('hhp-login-reload');
            }
        },
    },
};
</script>

<style scoped>
</style>


// WEBPACK FOOTER //
// src/skpComponents/view/basis/certificate/CertLoginSuccessPopup.vue